import React, { useState } from 'react';
import { motion } from 'framer-motion';

const BlogPage = () => {
    const categories = ['All', 'Tech', 'Design', 'Marketing'];

    const generateBlogs = () => {
        return Array.from({ length: 20 }, (_, i) => {
            const category = categories[(i % (categories.length - 1)) + 1];
            return {
                title: `Blog Post ${i + 1}`,
                image: `https://picsum.photos/seed/${i + 1}/400/200`,
                content: `This is a brief summary of blog post number ${i + 1}.`,
                category,
                date: new Date(2025, 5, i + 1).toDateString(), // e.g., June 1, 2025
            };
        });
    };

    const blogs = generateBlogs();
    const blogsPerPage = 8;

    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState('All');

    const filteredBlogs =
        selectedCategory === 'All'
            ? blogs
            : blogs.filter((b) => b.category === selectedCategory);

    const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);
    const start = (currentPage - 1) * blogsPerPage;
    const end = start + blogsPerPage;
    const currentBlogs = filteredBlogs.slice(start, end);

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        setCurrentPage(1); // reset to first page
    };

    return (
        <div className="container py-4">
            <div className="text-center mb-4">
                <p className="text-uppercase fw-bold mb-1">Our Process</p>
                <h2 className="section-title">
                    Our <span className="blue-text">Blogs</span>
                </h2>
            </div>

            {/* Category Filter */}
            <div className="d-flex justify-content-center gap-3 mb-4 flex-wrap">
                {categories.map((cat) => (
                    <button
                        key={cat}
                        onClick={() => handleCategoryChange(cat)}
                        className={`btn btn-sm ${selectedCategory === cat ? 'btn-csd15' : 'btn-border-csd '}`}
                    >
                        {cat}
                    </button>
                ))}
            </div>

            {/* Blog Cards */}
            <div className="row g-4">
                {currentBlogs.map((blog, index) => (
                    <motion.div
                        key={index}
                        className="col-lg-3 col-md-4 col-sm-6"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.05 }}
                    >
                        <div className="card h-100 shadow-sm blog-card">
                            <img
                                src={blog.image}
                                className="card-img-top"
                                alt={blog.title}
                                style={{ height: '180px', objectFit: 'cover' }}
                            />
                            <div className="card-body">
                                <h5 className="card-title">{blog.title}</h5>
                                <p className="text-muted small mb-2">{blog.date} • {blog.category}</p>
                                <p className="card-text">{blog.content}</p>
                                <a href="#" className="btn btn-sm btn-csd">
                                    Read More
                                </a>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>

            {/* Pagination */}
            <div className="pagination-container d-flex justify-content-center mt-4">
                <button
                    onClick={handlePrev}
                    className="btn btn-border-csd  mx-2"
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                <button
                    onClick={handleNext}
                    className="btn btn-border-csd  mx-2"
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default BlogPage;
